<div class="mat-typography" [formGroup]="newProjectGroup">
    <div class="dialog-header">
        {{ !data.project ? "Create New " : "Edit " }} {{ (!data.parent) ? 'Project' : 'Folder' }}
    </div>
    <div class="horizontal-separator"></div>

    <div class="dialog-container">
        <p class="input-label">
            {{ (data.parent?.is_root || !data.parent) ? "Project" : "Folder" }} Name
        </p>
        <mat-form-field appearance="outline">
            <input matInput formControlName="name" placeholder="Name" required>
            @if (newProjectGroup.get('name')?.hasError('required')) {
                <mat-error>
                    Name is required
                </mat-error>
            }
            @if (newProjectGroup.get('name')?.hasError('pattern')) {
                <mat-error>
                    Name contains forbidden characters <, >, :, ", /, \, |, ?, *
                </mat-error>
            }
            @if (fieldError('name')) {
                <mat-error>
                    {{fieldError('name')}}
                </mat-error>
            }

        </mat-form-field>
        <p class="input-label desc-label">
            <span>Short Description</span> <span class="opt-label">Optional</span>
        </p>
        <mat-form-field appearance="outline" class="textarea">
      <textarea matInput formControlName="description"
                placeholder="Short Description"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="5"></textarea>
                <div class="desc-label">
                    <span></span> <span class="opt-label" [ngClass]="{'error': descLength()>200}">{{ descLength() }}/200</span>
                </div>
            @if (fieldError('description')) {
                <mat-error>
                    fieldError('description')
                </mat-error>
            }
        </mat-form-field>

    </div>

</div>
<div class="button-row ">
    <button mat-button mat-dialog-close class="cancel-button" >Cancel</button>
    <button mat-button cdkFocusInitial class="frmg-primary-button" [disabled]="newProjectGroup.invalid"
            (click)="addProject()">{{ !data.project ? ("Create " +  (!data.parent ? 'Project' : 'Folder' )) : "Save Changes" }}
    </button>
</div>
